import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './Policies.css';

function ReturnPolicy() {
  return (
    <Container className="policy-page py-5">
      <h1 className="text-center mb-5">İade Politikası</h1>
      
      <Row className="g-4">
        <Col lg={8} className="mx-auto">
          <Card className="policy-card">
            <Card.Body>
              <section className="mb-5">
                <h4>İade Süreci</h4>
                <p>
                  Ürününüzü teslim aldıktan sonra iade talebinde bulunmak için 14 günlük bir süreniz bulunmaktadır.
                </p>
                <p>
                  İadeye uygun olabilmeniz için ürününüzün aldığınız haline uygun olması gerekmektedir, yani kullanılmamış olmalı ve orijinal ambalajında olmalıdır. Ayrıca, satın alma fişiniz veya kanıtınız da gerekecektir.
                </p>
                <p>
                  İade işlemine başlamak için bize mr.browncases@gmail.com adresinden ulaşabilir veya kullanıcı hesabınız varsa Siparişlerim ekranından iade talebi oluşturabilirsiniz.
                </p>
                <p>
                  Eğer iade talebiniz kabul edilirse, size bir iade kargo etiketi ve paketinizi nereye ve nasıl göndereceğiniz konusunda talimatlar göndereceğiz. İlk önce iade talebi olmadan gönderilen ürünler kabul edilmeyecektir.
                </p>
              </section>

              <section className="mb-5">
                <h4>Hasarlar ve Sorunlar</h4>
                <p>
                  Siparişinizi kargo şirketinden teslim alırken lütfen ambalajın durumunu kontrol edin, eğer ambalajda hasar mevcutsa kargo şirketine durumu bildirin. Siparişinizi teslim aldığınızda lütfen ürünü kontrol edin ve eğer üründe kusur, hasar veya yanlış ürün varsa derhal bizimle iletişime geçin, böylece sorunu değerlendirebilir ve düzeltebiliriz.
                </p>
              </section>

              <section className="mb-5">
                <h4>İstisnalar / İade Edilemeyen Ürünler</h4>
                <p>
                  Özel tasarım (kişiselleştirilmiş) telefon kılıfları iade edilemez. Bu ürünler sizin özel isteklerinize göre üretildiği için iade kapsamı dışındadır. Özel ürününüzle ilgili sorularınız veya endişeleriniz varsa lütfen bizimle iletişime geçin.
                </p>
              </section>

              <section className="mb-5">
                <h4>Değişimler</h4>
                <p>
                  İstediğiniz ürünü almanın en hızlı yolu mevcut ürünü iade etmek ve iade kabul edildikten sonra yeni ürün için ayrı bir satın alma yapmaktır. Değişim seçeneği mevcut değildir.
                </p>
              </section>

              <section>
                <h4>İade Ödemeleri</h4>
                <p>
                  İadenizi aldığımızda ve incelediğimizde size iade işleminin onaylandığını veya onaylanmadığını bildireceğiz. Onaylanırsa, iade tutarı otomatik olarak ilk ödeme yönteminizle 10 iş günü içinde iade edilecektir. Lütfen bankanızın veya kredi kartı şirketinizin iadeyi işleme koyması ve yayınlaması için biraz zaman alabileceğini unutmayın.
                </p>
                <p>
                  Eğer iadenizi onayladıktan sonra 15 iş gününden fazla zaman geçmişse, lütfen bize mr.browncases@gmail.com adresinden ulaşın.
                </p>
              </section>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default ReturnPolicy;